var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.17137 9.7255L7.02538 8.47992C7.71496 8.17845 8.26554 7.62787 8.56701 6.93829L9.81259 4.08428C9.91007 3.86225 10.2224 3.86225 10.3198 4.08428L11.5654 6.93829C11.8669 7.62787 12.4175 8.17845 13.1071 8.47992L15.9665 9.7273C16.1867 9.82298 16.1885 10.1371 15.9665 10.2346L13.0583 11.5199C12.3705 11.8249 11.8218 12.3773 11.5239 13.0687L10.318 15.8686C10.2224 16.0906 9.90646 16.0924 9.81078 15.8686L8.56701 13.0182C8.26554 12.3286 7.71496 11.778 7.02538 11.4765L4.17137 10.2309C3.94934 10.1335 3.94934 9.82117 4.17137 9.72369V9.7255Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.598077 4.32056L2.24802 3.60029C2.64697 3.42699 2.96468 3.10747 3.13798 2.71033L3.85825 1.06039C3.91421 0.932222 4.09473 0.932222 4.15069 1.06039L4.87096 2.71033C5.04426 3.10928 5.36377 3.42699 5.76091 3.60029L7.41266 4.32056C7.54083 4.37652 7.54083 4.55704 7.41266 4.613L5.73203 5.35674C5.33489 5.53184 5.01718 5.85316 4.84568 6.25211L4.14888 7.86956C4.09292 7.99773 3.9106 7.99773 3.85464 7.86956L3.13617 6.22323C2.96287 5.82428 2.64336 5.50657 2.24622 5.33327L0.596273 4.613C0.468105 4.55704 0.468105 4.37652 0.596273 4.32056H0.598077Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiLogo);
export default __webpack_public_path__ + "static/media/ai_logo.ea4ce47819d75a5d19ee577d6a150481.svg";
export { ForwardRef as ReactComponent };